import { FC } from 'react';

import ListIcon from '@mui/icons-material/List';
import Button from '@mui/material/Button';
import ToolCard from 'components/ToolCard';

const RoomPropertiesCard: FC = () => (
  <ToolCard
    icon={<ListIcon fontSize="large" />}
    title="Kambarių savybės"
    description="Kambarių savybių redagavimas"
    action={
      <Button href="room-properties" startIcon={<ListIcon />} size="small">
        Redaguoti
      </Button>
    }
  />
);

export default RoomPropertiesCard;
